module.exports = __webpack_public_path__ + "assets/img/rolling.5fd9e74f.svg";